export const SAMPLE_EVALUATIONS = [
  {
    id: "sample-58310427",
    evaluationId: "sample-58310427",
    signupEmail: "james.wilson@example.com",
    email: "james.wilson@example.com",
    score: 0.91,
    finalScore: 0.91,
    verdict: "BLOCK",
    reasonCodes: ["BOT_BEHAVIOUR", "VPN_PROXY"],
    createdAt: "2026-10-28T10:31:00.000Z",
    ipAddress: "185.220.101.24",
    signals: {
      email: {
        domain: "example.com",
        ageDays: 184,
        disposable: false,
        freeProvider: false,
        suspiciousTld: false,
        hasMX: true,
        spfRecord: "Configured",
        dmarcRecord: "Configured",
      },
      network: {
        country: "GB",
        asName: "Example Network Ltd",
        asn: "AS64521",
        isVpnProxy: true,
        isTor: false,
        isDatacenter: true,
        isThreatListed: false,
      },
      device: {
        deviceId: "dev_sample_58310427",
        known: false,
      },
      bot: {
        classification: "high risk automation",
        botScore: 0.94,
        honeypotTriggered: true,
      },
    },
    ruleMatches: [
      {
        name: "VPN + Threat Intel = Block",
        action: "block",
      },
    ],
  },

  {
    id: "sample-29174683",
    evaluationId: "sample-29174683",
    signupEmail: "alex.thompson@example.com",
    email: "alex.thompson@example.com",
    score: 0.74,
    finalScore: 0.74,
    verdict: "REVIEW",
    reasonCodes: ["REPEAT_DEVICE"],
    createdAt: "2026-10-28T10:29:00.000Z",
    ipAddress: "81.2.69.142",
    signals: {
      email: {
        domain: "example.com",
        ageDays: 620,
        disposable: false,
        freeProvider: false,
        suspiciousTld: false,
        hasMX: true,
        spfRecord: "Configured",
        dmarcRecord: "Configured",
      },
      network: {
        country: "GB",
        asName: "Example Broadband",
        asn: "AS64522",
        isVpnProxy: false,
        isTor: false,
        isDatacenter: false,
        isThreatListed: false,
      },
      device: {
        deviceId: "dev_sample_29174683",
        known: true,
      },
      bot: {
        classification: "human",
        botScore: 0.18,
        honeypotTriggered: false,
      },
    },
    ruleMatches: [
      {
        name: "Repeat Device Review",
        action: "review",
      },
    ],
    manualReview: {
      id: "sample-review-29174683",
      evaluationId: "sample-29174683",
      status: "open",
    },
  },

  {
    id: "sample-76420519",
    evaluationId: "sample-76420519",
    signupEmail: "ryan.parker@example.com",
    email: "ryan.parker@example.com",
    score: 0.82,
    finalScore: 0.82,
    verdict: "BLOCK",
    reasonCodes: ["DISPOSABLE_EMAIL"],
    createdAt: "2026-10-28T10:28:00.000Z",
    ipAddress: "51.38.64.18",
    signals: {
      email: {
        domain: "temporary-mail.example",
        ageDays: 12,
        disposable: true,
        freeProvider: false,
        suspiciousTld: false,
        hasMX: true,
        spfRecord: "Missing",
        dmarcRecord: "Missing",
      },
      network: {
        country: "GB",
        asName: "Example Hosting",
        asn: "AS64523",
        isVpnProxy: false,
        isTor: false,
        isDatacenter: true,
        isThreatListed: false,
      },
      device: {
        deviceId: "dev_sample_76420519",
        known: false,
      },
      bot: {
        classification: "likely human",
        botScore: 0.24,
        honeypotTriggered: false,
      },
    },
    ruleMatches: [
      {
        name: "Block Disposable Email",
        action: "block",
      },
    ],
  },

  {
    id: "sample-43891752",
    evaluationId: "sample-43891752",
    signupEmail: "michael.harris@example.com",
    email: "michael.harris@example.com",
    score: 0.12,
    finalScore: 0.12,
    verdict: "ALLOW",
    reasonCodes: [],
    createdAt: "2026-10-28T10:28:00.000Z",
    ipAddress: "86.14.73.21",
    signals: {
      email: {
        domain: "example.com",
        ageDays: 1450,
        disposable: false,
        freeProvider: false,
        suspiciousTld: false,
        hasMX: true,
        spfRecord: "Configured",
        dmarcRecord: "Configured",
      },
      network: {
        country: "GB",
        asName: "Example Residential Broadband",
        asn: "AS64524",
        isVpnProxy: false,
        isTor: false,
        isDatacenter: false,
        isThreatListed: false,
      },
      device: {
        deviceId: "dev_sample_43891752",
        known: true,
      },
      bot: {
        classification: "human",
        botScore: 0.04,
        honeypotTriggered: false,
      },
    },
    ruleMatches: [],
  },
];

export const SAMPLE_REVIEWS = SAMPLE_EVALUATIONS
  .filter((evaluation) => evaluation.verdict === "REVIEW")
  .map((evaluation) => ({
    id:
      evaluation.manualReview?.id ||
      `sample-review-${evaluation.id}`,
    evaluationId: evaluation.id,
    signupEmail: evaluation.signupEmail,
    score: evaluation.score,
    finalScore: evaluation.finalScore,
    reasonCodes: evaluation.reasonCodes,
    evaluationCreatedAt: evaluation.createdAt,
    createdAt: evaluation.createdAt,
    status: "open",
  }));

export const getSampleEvaluation = (id) =>
  SAMPLE_EVALUATIONS.find(
    (evaluation) =>
      String(evaluation.id) === String(id)
  ) || null;

export const isSampleEvaluationId = (id) =>
  String(id || "").startsWith("sample-");

export const shouldUseSampleData = (integration) => {
  if (!integration) return true;
  const status = String(integration.status || "").toLowerCase();
  if (status === "active" || status === "disabled") return false;
  if (status === "unprovisioned") return true;
  return integration.connected === false;
};
